export default "__VITE_ASSET__0d340a97__"